/* global sessionStorage, BroadcastChannel */
// We use BroadcastChannel to get inter-tab communication
const broadcastChannel = new BroadcastChannel('thematic_path_watcher')

const storeTPID = (obj) => {
    sessionStorage.setItem('lastSeenThematicPath', obj.data)
}

const getTPID = () => {
    const value = sessionStorage.getItem('lastSeenThematicPath')
    return value ? parseInt(value) : null
}

const refreshTPID = () => {
    const newId = document.body.querySelector('main').dataset.thematicPathId ?? undefined // null | str
    if (newId) {
        // console.log('new thematic path ID !')
        storeTPID({data: newId})
        broadcastChannel.postMessage(newId)
    }
    
    broadcastChannel.onmessage = storeTPID
}





export {
    refreshTPID,
    getTPID,
}